var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIncreasedPerformance = function SvgIncreasedPerformance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.318.808 15.168 20H5.335a.667.667 0 0 1-.542-1.059L18.125.274a.667.667 0 0 1 1.193.534z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 0.4,
    d: "M27.015 12.097a.666.666 0 0 1 .196.956L13.878 31.72a.666.666 0 0 1-1.194-.533L16.834 12h9.834c.123 0 .242.034.347.097z"
  })));
};
export default SvgIncreasedPerformance;